import { useQuery } from "@apollo/client";
import PreviewWrapper from "../../components/Preview/PreviewWrapper";
import { GET_WEBPAGE_QUERY, WebpageData } from "../../api/Requests";
import { useEffect, useState } from "react";
import { MyBigLoader } from "../../util/myLoader";

export default function FreshMode() {
  // TODO: Right now this rerenders everytime the FreshMode is called (we may want "limbo" data to be saved until website should be published)
  // The query data is cached after first load... which is great, but we need to fix "limbo" data
  const { loading, error, data } = useQuery<WebpageData>(GET_WEBPAGE_QUERY, {
    variables: {
      version: 1,
    },
  });
  const [firstLoad, setFirstLoad] = useState(true);

  // Allow the top menu to scroll out of view so the webpage is seen fully
  useEffect(() => {
    if (data && document !== null && firstLoad) {
      document.getElementById("top")?.scrollIntoView();
      setFirstLoad(false);
    }
  }, [data, firstLoad]);

  if (loading) {
    return <MyBigLoader />;
  }
  return error ? (
    <p>Error: {error.message}</p>
  ) : (
    data && <PreviewWrapper editEnabled previewData={data.webpage} />
  );
}
